import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './asset/pageIntroduction.module.scss';

const PageIntroduction = () => {
    const location = useLocation();
    const path = location.pathname;

    const [pageTitle, setPageTitle] = useState("Dashboard");
    const [pageDescription, setPageDescription] = useState("Your SAT progress overview");

    useEffect(() => {
        switch (true) {
            case path.includes("/user-sat-practice"):
                setPageTitle("Practice Mode");
                setPageDescription(`Master all the necessary skills to success`);
                break;
            case path.includes("/user-setting"):
                setPageTitle("Profile");
                setPageDescription("Manage your account settings");
                break;
            case path.includes("/user-dashboard"):
                setPageTitle("Dashboard");
                setPageDescription("All your progress in one place");
                break;
            default:
                setPageTitle("Dashboard");
                setPageDescription("All your progress in one place");
                break;
        }
    }, [path]);

    return (
        <div>
            <div className={styles.dashboard}>{pageTitle}</div>
            <div className={styles.yourSatProgress}>{pageDescription}</div>
        </div>
    );
};

export default PageIntroduction;
